import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../store/index";
import {
  addApiKeysRequest,
  deleteApiKeysRequest,
  deleteLasCreatedtApiKey,
  getApiKeysRequest,
  getRolesRequest,
  updateApiKeysRequest,
} from "../store/apiKeysDuck";
import type { ApiKeyConfig, ApiKeysRequestKey } from "../types/apiKeys";
import { combineErrors, combineStatuses } from "../utils";

export function useApiKeys() {
  const dispatch = useDispatch();

  const { apiKeys, roles, lastCreatedApiKey } = useSelector(
    (state: RootState) => state.apiKeys,
  );

  const loadApiKeys = () => {
    dispatch(getApiKeysRequest());
  };

  const loadRoles = () => {
    dispatch(getRolesRequest());
  };

  const generateApiKey = (apiKey: ApiKeyConfig) => {
    dispatch(addApiKeysRequest({ apiKey }));
  };

  const updateApiKey = (apiKey: ApiKeyConfig) => {
    dispatch(updateApiKeysRequest({ apiKey }));
  };

  const removeApiKey = (id: string) => {
    dispatch(deleteApiKeysRequest({ id }));
  };

  const removeLastCreatedApiKey = () => {
    dispatch(deleteLasCreatedtApiKey());
  };

  const getRequestStatus = (request: ApiKeysRequestKey | ApiKeysRequestKey[]) =>
    useSelector((state: RootState) => {
      const requests = Array.isArray(request) ? request : [request];
      return combineStatuses(
        requests.map((key) => state.apiKeys.requests[key].status),
      );
    });

  const getRequestError = (request: ApiKeysRequestKey | ApiKeysRequestKey[]) =>
    useSelector((state: RootState) => {
      const requests = Array.isArray(request) ? request : [request];

      return combineErrors(
        requests.map((key) => state.apiKeys.requests[key].error),
      );
    });

  return {
    apiKeys,
    roles,
    loadApiKeys,
    loadRoles,
    generateApiKey,
    updateApiKey,
    removeApiKey,
    lastCreatedApiKey,
    removeLastCreatedApiKey,
    getRequestStatus,
    getRequestError,
  };
}
